class UABaseFacetFilters extends HTMLElement {
  constructor() {
    super();
    this.currentForm = this.querySelector("form.facets");
    this.facetFilters = [];

    this.elementSelectors = {
      productGrid: "main #product-grid",
      searchHeaderProductGrid: "search-results #product-grid",
      facetDrawerGroups: [],
      activeFacetsCount: "[data-active-facets-count]",
      activeFacetsGroupCount: [],
      productsCountLabel: "[data-products-count-label]",
      productsCount: "[data-products-count]",
      totalProductsCountLabel: "[data-total-products-count-label]",
      totalProductsCount: "[data-total-products-count]",
      selectSortBy: "facets-sort-by",
      paginationSelector: ".pagination-wrapper",
      clearAllSelector: "facets-clear-all",
      collapsibleFacetContent: "collapsible-content.facet-group",
    };

    this.classes = {
      loading: "loading",
    };

    document.querySelectorAll(this.elementSelectors.collapsibleFacetContent).forEach((facetGroup) => {
      this.elementSelectors.activeFacetsGroupCount.push(`#${facetGroup.id} [data-active-facets-group-count]`);
    });

    document.querySelectorAll(this.elementSelectors.collapsibleFacetContent).forEach((facetGroup) => {
      this.elementSelectors.facetDrawerGroups.push(`#${facetGroup.id} .collapsible__content`);
    });

    if (this.elementSelectors.facetDrawerGroups.length === 0) {
      return;
    }

    this.setElements();
  }

  setElements() {
    if (!this.isHeaderSearchOpen()) {
      this.productGridEl = document.querySelectorAll(this.elementSelectors.productGrid);
    } else {
      this.productGridEl = document.querySelectorAll(this.elementSelectors.searchHeaderProductGrid);
    }

    this.facetDrawerGroupsEl = document.querySelectorAll(this.elementSelectors.facetDrawerGroups);
    this.activeFacetsCountEl = document.querySelectorAll(this.elementSelectors.activeFacetsCount);
    this.activeFacetsGroupCountEl = document.querySelectorAll(this.elementSelectors.activeFacetsGroupCount);
    this.productsCountLabelEl = document.querySelectorAll(this.elementSelectors.productsCountLabel);
    this.productsCountEl = document.querySelectorAll(this.elementSelectors.productsCount);
    this.totalProductsCountLabelEl = document.querySelectorAll(this.elementSelectors.totalProductsCountLabel);
    this.totalProductsCountEl = document.querySelectorAll(this.elementSelectors.totalProductsCount);
    this.selectSortByEl = document.querySelectorAll(this.elementSelectors.selectSortBy);
    this.paginationSelectorEl = document.querySelectorAll(this.elementSelectors.paginationSelector);
    this.clearAllSelectorEl = document.querySelectorAll(this.elementSelectors.clearAllSelector);
  }

  getSearchResultsUrl() {
    this.facetFilters = this.getFacetsData();

    let queryString = "";
    for (const key in this.facetFilters) {
      if (this.facetFilters.hasOwnProperty(key)) {
        const values = this.facetFilters[key];
        if (Array.isArray(values)) {
          values.forEach((value) => {
            queryString += `${encodeURIComponent(key)}=${encodeURIComponent(value)}&`;
          });
        } else {
          queryString += `${encodeURIComponent(key)}=${encodeURIComponent(values)}&`;
        }
      }
    }
    // Remove the trailing '&'
    queryString = queryString.slice(0, -1);

    return `${window.Shopify.routes.root}search?${queryString}`;
  }

  getFacetsData() {
    this.currentForm = this.querySelector("form.facets");

    let formData = new FormData(this.currentForm);

    const data = {};
    formData.forEach((value, key) => {
      if (data[key]) {
        if (!Array.isArray(data[key])) {
          data[key] = [data[key]];
        }
        data[key].push(value);
      } else {
        data[key] = value;
      }
    });

    this.formDataAssignCheckboxes(data);
    this.formDataRemoveDuplicates(data);

    return data;
  }

  formDataAssignCheckboxes(data) {
    const checkboxes = this.currentForm.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      if (!data[checkbox.name]) {
        data[checkbox.name] = [];
      }
      if (checkbox.checked) {
        if (Array.isArray(data[checkbox.name])) {
          data[checkbox.name].push(checkbox.value);
        } else {
          data[checkbox.name] = [checkbox.value];
        }
      }
    });
  }

  formDataRemoveDuplicates(data) {
    Object.keys(data).forEach((key) => {
      const value = data[key];
      if (Array.isArray(value)) {
        data[key] = [...new Set(value)];
      }
    });
  }

  updateBrowserURL() {
    this.facetFilters = this.getFacetsData();

    let url = window.location.pathname;

    let params = new URLSearchParams();
    params.delete("page");

    const loadPreviousProductsButton = document.querySelector("load-previous-products");
    loadPreviousProductsButton?.classList.add("hidden");

    Object.keys(this.facetFilters).forEach((key) => {
      const value = this.facetFilters[key];
      if (Array.isArray(value)) {
        value.forEach((v) => params.append(key, v));
      } else {
        params.set(key, value);
      }
    });

    window.history.pushState({}, "", `${url}?${params.toString()}`);
  }

  getParsedData(data) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(data, "text/html");

    return doc;
  }

  scrollPageToTop() {
    if (window.innerWidth <= 749) {
      window.scrollTo(0, 0);
    }
  }

  isHeaderSearchOpen() {
    return document.documentElement.classList.contains("header-search--open");
  }

  updateElements(data, previousData) {
    this.parsedDoc = this.getParsedData(data);
    this.previousData = previousData;

    this.updateProductGrid();

    if (!this.isHeaderSearchOpen() && document.body.id === "template-collection") {
      buildFeaturedCSS();
    }

    this.updateFacetDrawer();
    this.updateActiveFacetsCount();
    this.updateClearAllVisibility();
    this.updateActiveFacetsGroupCount();
    this.updateProductsCountLabel();
    this.updateProductsCount();
    this.updateTotalProductsCountLabel();
    this.updateTotalProductsCount();
    this.updateSortBy();
    this.scrollPageToTop();

    if (!this.previousData) {
      this.updatePagination();
      const LayoutToggle = document.querySelector("layout-toggle");

      if (LayoutToggle) {
        LayoutToggle.classList.remove("all-products-loaded");

        if (typeof LayoutToggle.hideOverhangingProducts === "function") {
          LayoutToggle?.hideOverhangingProducts();
          LayoutToggle.updateProductCountsToVisible();
        }
      }
    } else {
      this.updatePreviousButton();
      document.dispatchEvent(new CustomEvent("previous-items-loaded"));
    }

    // Datalayer tracking
    document.dispatchEvent(new CustomEvent("product-list:updated"));
  }

  renderWishlistButtons() {
    let productGridSelector = "main #product-grid";

    if (this.isHeaderSearchOpen()) {
      productGridSelector = "header-search #product-grid";
    }

    document.dispatchEvent(
      new CustomEvent("swym:refresh-products", {
        detail: {
          selector: productGridSelector,
        },
      })
    );
  }

  renderTrustPilotBadges() {
    let productGridSelector = "main #product-grid";

    if (this.isHeaderSearchOpen()) {
      productGridSelector = "header-search #product-grid";
    }

    document.dispatchEvent(
      new CustomEvent("trustpilot:render-product-mini-widgets", {
        detail: {
          productContainerSelector: productGridSelector,
        },
      })
    );
  }

  updateHrefLangs(doc) {
    const hrefLangs = doc.querySelectorAll('link[rel="alternate"]');
    const head = document.querySelector("head");

    hrefLangs.forEach((hrefLang) => {
      const lang = hrefLang.getAttribute("hreflang");
      let href = hrefLang.getAttribute("href");
      const existingHrefLang = head.querySelector(`link[hreflang="${lang}"]`);

      if (href.includes("?page=1")) {
        href = href.replace("?page=1", "");
      }

      if (existingHrefLang) {
        existingHrefLang.setAttribute("href", href);
      } else {
        head.appendChild(hrefLang);
      }
    });
  }

  updateCanonicalLink(doc) {
    const canonicalLink = doc.querySelector('link[rel="canonical"]');
    const head = document.querySelector("head");
    const existingCanonicalLink = head.querySelector('link[rel="canonical"]');
    let href = canonicalLink.getAttribute("href");

    if (href.includes("?page=1")) {
      href = href.replace("?page=1", "");
    }

    if (existingCanonicalLink) {
      existingCanonicalLink.setAttribute("href", href);
    } else {
      head.appendChild(canonicalLink);
    }
  }

  getPreviousData() {
    return fetch(window.location.href)
      .then((response) => response.text())
      .then((data) => {
        this.updateElements(data, true);
        this.updateHrefLangs(this.parsedDoc);
        this.updateCanonicalLink(this.parsedDoc);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  setGroupLoadingState(collapsibleContent, state) {
    if (!collapsibleContent) {
      return;
    }

    if (state == "loading") {
      collapsibleContent.classList.add(this.classes.loading);
    } else if (state == "loaded") {
      collapsibleContent.classList.remove(this.classes.loading);
    }
  }

  fetchData(collapsibleContent) {
    this.setGroupLoadingState(collapsibleContent, "loading");

    let url = window.location.href;
    if (document.documentElement.classList.contains("header-search--open")) {
      url = this.getSearchResultsUrl();
    }

    return fetch(url)
      .then((response) => response.text())
      .then((data) => {
        this.updateElements(data);
        this.setGroupLoadingState(collapsibleContent, "loaded");
        // Datalayer tracking
        document.dispatchEvent(new CustomEvent("update-tracking-buttons"));
      })
      .catch((error) => {
        this.setGroupLoadingState(collapsibleContent, "loaded");
        console.error("Error fetching data:", error);
      });
  }

  updatePreviousButton() {
    const loadPreviousProductsButton = document.querySelector("load-previous-products");
    loadPreviousProductsButton.classList.remove("loading");
    loadPreviousProductsButton.querySelector(".loading-overlay__spinner")?.classList.add("hidden");

    if (loadPreviousProductsButton.dataset.pageIndex == "1") {
      loadPreviousProductsButton.classList.add("hidden");
    }
  }

  updateProductGrid() {
    this.productGridEl.forEach((element) => {
      const newProductGrid = this.parsedDoc.querySelector(this.elementSelectors.productGrid);

      if (this.previousData) {
        let currentScroll = window.scrollY;
        let oldContentHeight = document.body.scrollHeight;

        const fragment = document.createDocumentFragment();
        Array.from(newProductGrid.children).forEach((child) => fragment.appendChild(child));

        element.prepend(fragment);
        let newContentHeight = document.body.scrollHeight;
        let newScrollPosition = currentScroll + (newContentHeight - oldContentHeight);
        window.scrollTo(0, newScrollPosition);
      } else {
        const fragment = document.createDocumentFragment();
        Array.from(newProductGrid.children).forEach((child) => fragment.appendChild(child));

        element.innerHTML = "";
        element.appendChild(fragment);
      }

      this.renderWishlistButtons();
      this.renderTrustPilotBadges();
    });
  }

  updateFacetDrawer() {
    this.facetDrawerGroupsEl.forEach((element) => {
      let facetGroupId = element.closest("collapsible-content.facet-group").id;
      let parsedElement = this.parsedDoc.querySelector(`#${facetGroupId} .collapsible__content`);
      if( parsedElement ) {
        element.innerHTML = parsedElement.innerHTML;
      }
    });
  }

  updateActiveFacetsGroupCount() {
    this.activeFacetsGroupCountEl.forEach((element) => {
      let facetGroupId = element.closest("collapsible-content.facet-group").id;
      let parsedElement = this.parsedDoc.querySelector(`#${facetGroupId} [data-active-facets-group-count]`);
      if( parsedElement ) {
        element.dataset.activeFacetsGroupCount = parsedElement.dataset.activeFacetsGroupCount;
      }
    });
  }

  updateActiveFacetsCount() {
    this.activeFacetsCountEl.forEach((element) => {
      element.dataset.activeFacetsCount = this.parsedDoc.querySelector(this.elementSelectors.activeFacetsCount).dataset.activeFacetsCount;
    });
  }

  updateClearAllVisibility() {
    this.clearAllSelectorEl.forEach((element) => {
      let filters = Object.keys(this.facetFilters).filter((key) => this.facetFilters[key].length > 0);
      filters = filters.filter((key) => key !== "sort_by" && key !== "page");

      if (filters.length > 0) {
        element.classList.remove("hidden");
      } else {
        element.classList.add("hidden");
      }
    });
  }

  updateProductsCountLabel() {
    this.productsCountLabelEl.forEach((element) => {
      element.dataset.productsCountLabel = this.parsedDoc.querySelector(this.elementSelectors.productsCountLabel).dataset.productsCountLabel;
    });
  }

  updateProductsCount() {
    this.productsCountEl.forEach((element) => {
      element.dataset.productsCount = this.parsedDoc.querySelector(this.elementSelectors.productsCount).dataset.productsCount;
    });
  }

  updateTotalProductsCountLabel() {
    this.totalProductsCountLabelEl.forEach((element) => {
      element.dataset.totalProductsCountLabel = this.parsedDoc.querySelector(this.elementSelectors.totalProductsCountLabel).dataset.totalProductsCountLabel;
    });
  }

  updateTotalProductsCount() {
    this.totalProductsCountEl.forEach((element) => {
      element.dataset.totalProductsCount = this.parsedDoc.querySelector(this.elementSelectors.totalProductsCount).dataset.totalProductsCount;
    });
  }

  updateSortBy() {
    this.selectSortByEl.forEach((element) => {
      const selectSortBy = this.parsedDoc.querySelector(this.elementSelectors.selectSortBy);
      if (!selectSortBy) {
        return;
      }

      if (element.parentNode) {
        element.outerHTML = selectSortBy.outerHTML;
      } else {
        element.innerHTML = selectSortBy.innerHTML;
      }
    });
  }

  updatePagination() {
    this.paginationSelectorEl.forEach((element) => {
      const paginationSelector = this.parsedDoc.querySelector(this.elementSelectors.paginationSelector);
      if (paginationSelector) {
        element.innerHTML = paginationSelector.innerHTML;
        element.classList.remove("hidden");
      } else {
        element.innerHTML = "";
      }
    });
  }
}

class UAFacetsFiltersForm extends UABaseFacetFilters {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentForm.addEventListener("change", (evt) => {
      const collapsibleContent = evt.target.closest("collapsible-content");

      if (evt.target.type == "text" && collapsibleContent.querySelector('label.icon-bg')) {
        return;
      }

      if (this.isHeaderSearchOpen()) {
        this.getFacetsData();
        this.fetchData(collapsibleContent);
      } else {
        this.updateBrowserURL();
        this.fetchData(collapsibleContent);
      }
    });
  }
}

class UAFacetsSortBy extends UABaseFacetFilters {
  constructor() {
    super();
  }

  connectedCallback() {
    const selectEl = this.querySelector("select");
    selectEl.addEventListener("change", (evt) => {
      const selectedValue = selectEl.value;
      this.updateBrowserURL(selectedValue);
    });
  }

  disconnectedCallback() {
    const selectEl = this.querySelector("select");
    selectEl.removeEventListener("change", (evt) => {
      const selectedValue = selectEl.value;
      this.updateBrowserURL(selectedValue);
    });
  }

  updateBrowserURL(selectedValue) {
    const params = new URLSearchParams(window.location.search);
    params.set("sort_by", selectedValue);
    params.delete("page");

    const loadPreviousProductsButton = document.querySelector("load-previous-products");
    loadPreviousProductsButton?.classList.add("hidden");
    window.history.pushState({}, "", `${window.location.pathname}?${params.toString()}`);
    this.fetchData();
  }
}

class UAFacetsClearAllButton extends UABaseFacetFilters {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (evt) => {
      evt.preventDefault();

      const clearAll = this.querySelector(".facets__clear");
      if (!clearAll) return;

      const resultsUrl = clearAll.getAttribute("href");

      window.history.pushState({}, "", resultsUrl);

      const loadPreviousProductsButton = document.querySelector("load-previous-products");
      loadPreviousProductsButton?.classList.add("hidden");

      this.fetchData();
    });
  }
}

customElements.define("facets-filters-form", UAFacetsFiltersForm);
customElements.define("facets-sort-by", UAFacetsSortBy);
customElements.define("facets-clear-all", UAFacetsClearAllButton);
